@if(strategyOptions.length){
<div class="strategy-home-page" [attr.dir]="dir">
  
  <!-- Top Stats Cards -->
  <section class="stats-section">
    <div class="stats-grid">
      
      <!-- Card 1: Pillars -->
      <div class="stat-card card-teal">
        <div class="stat-icon">
          <i class="fa-solid fa-layer-group"></i>
        </div>
        <div class="stat-content">
          <div class="stat-label">{{'pillars'|translate}}</div>
          <div class="stat-value">{{getTotalPillarsCount()}}</div>
        </div>
      </div>

      <!-- Card 2: Goals -->
      <div class="stat-card card-orange">
        <div class="stat-icon">
          <i class="fa-solid fa-bullseye"></i>
        </div>
        <div class="stat-content">
          <div class="stat-label">{{'goals'|translate}}</div>
          <div class="stat-value">{{getTotalGoalsCount()}}</div>
        </div>
      </div>

      <!-- Card 3: Indicators -->
      <div class="stat-card card-purple">
        <div class="stat-icon">
          <i class="fa-solid fa-chart-line"></i>
        </div>
        <div class="stat-content">
          <div class="stat-label">{{'indicators'|translate}}</div>
          <div class="stat-value">{{getTotalIndicatorsCount()}}</div>
        </div>
      </div>

      <!-- Card 4: Projects -->
      <div class="stat-card card-green">
        <div class="stat-icon">
          <i class="fa-solid fa-lightbulb"></i>
        </div>
        <div class="stat-content">
          <div class="stat-label">{{'projects'|translate}}</div>
          <div class="stat-value">{{getTotalProjectsCount()}}</div>
        </div>
      </div>

    </div>
  </section>

  <!-- Pillars Overview Card -->
  <section class="overview-section">
    <div class="overview-card">
      
      <!-- Card Header with Title and Pillar Selector -->
      <div class="overview-header">
        <h2 class="overview-title">{{ dir === 'rtl' ? 'الأهداف' : 'Goals' }}</h2>
        <div class="pillar-selector">
          <p-dropdown 
            [(ngModel)]="selectedPillar"
            [options]="alignmentStrategy?.pillars || []"
            optionLabel="name"
            [placeholder]="dir === 'rtl' ? 'اختر المحور' : 'Select Pillar'"
            (onChange)="onPillarChange()"
            styleClass="pillar-dropdown">
          </p-dropdown>
        </div>
      </div>

      <!-- Goals Grid -->
      <div class="goals-grid">
        @if(selectedPillar && selectedPillar.goals) {
          @for (goal of selectedPillar.goals; track goal.id; let i = $index) {
            <div class="goal-card">
              <div class="goal-header">
                <div class="goal-badge">{{i + 1}}</div>
                <h3 class="goal-title">{{goal.name}}</h3>
              </div>
              <div class="goal-footer">
                <span class="goal-tag">{{goal.no_indicators || 0}} {{'indicators'|translate}}</span>
              </div>
            </div>
          }
        }
        @if(!selectedPillar || selectedPillar.goals?.length === 0) {
          <div class="empty-state">
            <i class="pi pi-inbox"></i>
            <p>{{ dir === 'rtl' ? 'اختر محوراً لعرض الأهداف' : 'Select a pillar to view goals' }}</p>
          </div>
        }
      </div>

    </div>
  </section>

</div>
}
@else {
<div class="empty-strategy-state">
    <div class="empty-content">
        <i class="fa-solid fa-clipboard-list"></i>
        <h1>{{ dir === 'rtl' ? 'لا توجد استراتيجيات متاحة!' : 'No strategies available!' }}</h1>
        <p>{{ dir === 'rtl' ? 'بادر بإعداد ومتابعة مبادراتك ومؤشراتك للمساهمة في تحقيق الأهداف بمجرد إعداد مدير الاستراتيجية للخطة!' : 'Start preparing and following up on your initiatives and indicators to contribute to achieving goals as soon as the strategy is ready!' }}</p>
    </div>
</div>
}
